import React, { Fragment } from 'react';
import { ContactHelmet } from '../components/MoiPayHelmet';
import ContactUsComponent from '../components/contact_v2/contact_us_component';

export default function ContactUsScreen() {
    return (
        <Fragment>
            <ContactHelmet />
            <ContactUsComponent />
        </Fragment>
    );
}
